import { CONFIG } from '../../core/config';
import { Recommendation } from './recommendation';

export class InspectionPlanTask extends Recommendation {
  constructor() {
    super();
    this.friendlyTypeNameSingular = 'inspectionPlanTask';
    this.apiRoute = CONFIG.apiRoutes.inspectionPlanTask;
  }
}
